import axios from 'axios';
//"axios-Every reques twe want to sent, will have the same starting url"

/** base url to make request to the movie database */
const instance = axios.create({
    baseURL: "https://api.themoviedb.org/3"
});

/**how the baseURL works is, everytime an instance of that baseURl is created its merged with the baseURL
 * e.g instance.get('/foo-bar)
 * Will return https://api.themoviedb.org/3/foo-bar, appends the request to baseurl
 */
export default instance